import {checkRefreshTarget, checkRefreshProfile} from "../dashboard-pro/index.js";
// import ioV4 from "socket.io-client";

export {
    initDashboardSocket,
    isSocketConnected,
    subscribeWidget,
    unsubscribeAllProject,
    receiveMainSocket,
}

let socket = null;
let isConnecting = false;
let SUBSCRIBE_LIST = []
const PUBLISH_TYPE = {
    USER_ID: '0',
    COLABO_SRNO: '1'
}

function isSocketConnected() {
    return socket?.connected
}

async function initDashboardSocket() {
    if (!Mutil.isFunc('MAIN_SOCKET') || !Mutil.isFunc('PLAN_DASHBOARD')) return;
    if (!_DASHBOARD_SOCKET_URL) return;
    if(await connectSocket()) receiveMainSocket();
}

async function connectSocket() {
    if(isConnecting) return false;
    if(socket === null){
        isConnecting = true;
        const ioV4 = await import('socket.io-client');
        socket = ioV4.connect(_DASHBOARD_SOCKET_URL, {
            rememberUpgrade: true,
            query: {
                "token": window._JSESSION_ID
            }
        });
        return true
    }
}

/**
 * @description 위젯 구독
 * @param data
 */
function subscribeWidget(data) {
    if (!Mutil.isFunc('MAIN_SOCKET') || !Mutil.isFunc('PLAN_DASHBOARD')) return;
    if (!socket) {
        initDashboardSocket();
    }

    if (JSON.stringify(SUBSCRIBE_LIST).indexOf(JSON.stringify(data)) < 0) {
        SUBSCRIBE_LIST.push(data)
        socket?.emit('dashboard', [data]);
    } else {
        // u.clog('이미 구독중인 프로젝트입니다.')
    }
}

/**
 * @description 프로젝트 구독 일괄 취소
 * @param data
 */
function unsubscribeAllProject() {
    if (!Mutil.isFunc('MAIN_SOCKET')) return;
    if (!socket) return;

    socket?.emit('leaveAll', {USER_ID: _USER_ID});
    socket?.disconnect();
    socket = null;
    SUBSCRIBE_LIST = []
}

function receiveMainSocket() {
    if (!Mutil.isFunc('MAIN_SOCKET') || !Mutil.isFunc('PLAN_DASHBOARD')) return;
    if (!socket) return;

    socket.on("receiveProject", (data) => {
        Mutil.clog(`[receiveProject]  : `, data)
        if (!data.COLABO_SRNO) return;
        checkRefreshTarget(data);
    })
    socket.on("receiveUser", (data) => {
        Mutil.clog(`[receiveUser]  : `, data)
        checkRefreshTarget(data);
    })
    socket.on("receiveMine", (data) => {
        Mutil.clog(`[receiveMine]  : `, data)
        checkRefreshProfile(data);
    })
    socket.on("connection", () => {
        Mutil.clog(`[connect!]`)
        isConnecting = true;
    })
    socket.on("disconnect", () => {
        Mutil.clog(`[disconnect!]`)
        isConnecting = false;
    })
}
